module.exports = __webpack_public_path__ + "media/images/orni_quiz/start_quiz-e8ee1bf9a28e4474d7431df6deda7230.png";